module.exports = __webpack_public_path__ + "media/target_area_icon/dept_sales-1079f871.png";